ci_states.state('docs', {
    url: '/docs',
    templateUrl: 'partials/docs/docs_list.html',
    controller: 'DocumentationController',
    ncyBreadcrumb: {
        label: 'Documentation'
    }
}).state('docs_ios', {
    url: '/docs/ios:version',
    templateUrl: function (stateParams) {
        var version = stateParams.version || '1120';
        return 'partials/application/wizard/ios_' + version + '/all.html';
    },
    controller: 'SdkIosDocumentationController',
    ncyBreadcrumb: {
        parent: 'docs',
        label: 'iOS SDK Documentation'
    }
}).state('docs_migration_ios_from_160', {
    url: '/docs/ios:version/migration_from_160',
    templateUrl: function (stateParams) {
        var version = stateParams.version || '1170';
        return 'partials/application/wizard/ios_' + version + '/migration_notes_160.html';
    },
    controller: 'SdkIosDocumentationController',
    ncyBreadcrumb: {
        label: 'iOS SDK Documentation'
    }
}).state('docs_android', {
    url: '/docs/android:version',
    templateUrl: function (stateParams) {
        var version = stateParams.version || '1170';
        var path = 'partials/application/wizard/android_' + version + '/all.html'
        console.log(path)
        return path;
    },
    controller: 'SdkAndroidDocumentationController',
    ncyBreadcrumb: {
        label: 'Android SDK Documentation'
    }
}).state('docs_migration_android_from_1140', {
    url: '/docs/android:version/migration_from_1140',
    templateUrl: function (stateParams) {
        var version = stateParams.version || '1170';
        return 'partials/application/wizard/android_' + version + '/migration_notes_1140.html';
    },
    controller: 'SdkAndroidDocumentationController',
    ncyBreadcrumb: {
        label: 'Android SDK Documentation'
    }
}).state('docs_js', {
    url: '/docs/js',
    templateUrl: function (stateParams) {
        var version = stateParams.version || '160';
        return 'partials/application/wizard/js/all.html';
    },
    controller: 'SdkJSDocumentationController',
    ncyBreadcrumb: {
        label: 'Javascript SDK Documentation'
    }
}).state('migration_notes_android', {
    url: '/docs/android/migration_notes',
    templateUrl: 'partials/application/wizard/android_migration_notes.html',
    controller: 'SdkMigrationNotesAndroidController',
    ncyBreadcrumb: {
        parent: 'docs_android',
        label: 'Android SDK Migration Notes'
    }
}).state('custom_firebase_setup', {
    url: '/docs/android/custom_firebase_setup',
    templateUrl: 'partials/application/wizard/android_custom_firebase_setup.html',
    controller: 'SdkMigrationNotesAndroidController',
    ncyBreadcrumb: {
        parent: 'docs_android',
        label: 'Custom Firebase Setup'
    }
}).state('android_opt_out_fields', {
    url: '/docs/android/opt_out_user_info',
    templateUrl: 'partials/application/wizard/android_opt_out_fields.html',
    controller: 'SdkOptOutAndroidController',
    ncyBreadcrumb: {
        parent: 'docs_android',
        label: 'Android SDK Opt-Out User Information Sharing'
    }
}).state('ios_opt_out_fields', {
    url: '/docs/ios/opt_out_user_info',
    templateUrl: 'partials/application/wizard/ios_opt_out_fields.html',
    controller: 'SdkOptOutIosController',
    ncyBreadcrumb: {
        parent: 'docs_ios',
        label: 'iOS SDK Opt-Out User Information Sharing'
    }
}).state('unity_opt_out_fields', {
    url: '/docs/unity/opt_out_user_info',
    templateUrl: 'partials/application/wizard/unity_opt_out_fields.html',
    controller: 'SdkOptOutUnityController',
    ncyBreadcrumb: {
        parent: 'docs_unity_android',
        label: 'Unity SDK Opt-Out User Information Sharing'
    }
});
ci_states.state('docs_unity_ios', {
    url: '/docs/unity_ios:version',
    templateUrl: function (stateParams) {
        var version = stateParams.version || '190';
        return 'partials/application/wizard/unity_ios_' + version + '/all.html';
    },
    controller: 'SdkUnityIosDocumentationController',
    ncyBreadcrumb: {
        label: 'Unity iOS SDK Documentation'
    }
}).state('docs_unity_android', {
    url: '/docs/unity_android:version',
    templateUrl: function (stateParams) {
        var version = stateParams.version || '190';
        return 'partials/application/wizard/unity_android_' + version + '/all.html';
    },
    controller: 'SdkUnityAndroidDocumentationController',
    ncyBreadcrumb: {
        label: 'Unity Android SDK Documentation'
    }
}).state('docs_react_native_android', {
    url: '/docs/react_native_android:version',
    templateUrl: function (stateParams) {
        var version = stateParams.version || '180';
        return 'partials/application/wizard/react_native_android_' + version + '/all.html';
    },
    controller: 'SdkReactNativeAndroidDocumentationController',
    ncyBreadcrumb: {
        label: 'React Native Android SDK Documentation'
    }
}).state('docs_react_native_ios', {
    url: '/docs/react_native_ios:version',
    templateUrl: function (stateParams) {
        var version = stateParams.version || '180';
        return 'partials/application/wizard/react_native_ios_' + version + '/all.html';
    },
    controller: 'SdkReactNativeIosDocumentationController',
    ncyBreadcrumb: {
        label: 'React Native iOS SDK Documentation'
    }
}).state('docs_ad_unity', {
    url: '/docs/ad_unity:version',
    templateUrl: function (stateParams) {
        var version = stateParams.version || '11';
        return 'partials/application/connectedadsdk/unity_' + version + '/all.html';
    },
    controller: 'AdSdkUnityDocumentationController',
    ncyBreadcrumb: {
        label: 'Connect AD SDK Unity Documentation'
    }
}).state('docs_ad_android', {
    url: '/docs/ad_android:version',
    templateUrl: function (stateParams) {
        var version = stateParams.version || '11';
        return 'partials/application/connectedadsdk/android_' + version + '/all.html';
    },
    controller: 'AdSdkAndroidDocumentationController',
    ncyBreadcrumb: {
        label: 'Connected AD SDK Android Documentation'
    }
}).state('docs_ad_ios', {
    url: '/docs/ad_ios:version',
    templateUrl: function (stateParams) {
        var version = stateParams.version || '11';
        return 'partials/application/connectedadsdk/ios_' + version + '/all.html';
    },
    controller: 'AdSdkIOSDocumentationController',
    ncyBreadcrumb: {
        label: 'Connected AD SDK iOS Documentation'
    }
}).state('docs_flutter', {
    url: '/docs/flutter:version',
    templateUrl: function (stateParams) {
        var version = stateParams.version || '101';
        return 'partials/application/wizard/flutter_' + version + '/all.html';
    },
    controller: 'SdkFlutterDocumentationController',
    ncyBreadcrumb: {
        label: 'Connected SDK Flutter Documentation'
    }
});
